import { createSignal } from "solid-js"
import { PaintTileOption } from "../../lib/core/map_editor/paint_tile_option"
import createSharedCachedFactory from "../memo/createSharedCachedFactory"
import { defaultPaintTileOption } from "../../lib/core/map_editor/paint_tile_option_list"
import { isPlainObjDeeplyEqual } from "../../lib/isPlainObjDeeplyEqual"

export const usePaintTileOptionSignal = createSharedCachedFactory((
    // engine: Engine
) => {

    // eslint-disable-next-line solid/reactivity
    const signal = createSignal<PaintTileOption>(defaultPaintTileOption(), {
        equals: isPlainObjDeeplyEqual,
    })

    return signal
})


